import { Outlet } from 'react-router-dom';

/* eslint-disable-next-line */
export interface SurveyProps {}

export function Survey(props: SurveyProps) {
  return (
    <div className="bg-light-primary-opacity-60 dark:bg-dark-primary-opacity-60 rounded-none sm:rounded-xl text-light-secondary dark:text-custom-textColor p-6 pb-20 sm:p-14">
      <Outlet />
    </div>
  );
}

export default Survey;
